import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ReplyIcon from '@mui/icons-material/Reply';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { PortfolioDetailsFundReportItem, PortfolioDetailsReportItem } from '../../../../models/Portfolio';
import { LeoDocumentsPath, LeoDocumentsPathExample } from '../../../../resources/api-constants';
import { useTranslation } from 'react-i18next';

export interface ICollapsableReportsProps{
    title: string;
    reports: PortfolioDetailsReportItem[] | PortfolioDetailsFundReportItem[];
    defaultOpened?: boolean;
}

const CollapsableReports: React.FC<ICollapsableReportsProps> = ({ title, reports, defaultOpened }) => {
    const { t } = useTranslation();
    const [ collapsed, setCollapsed] = useState(defaultOpened ? false : true);

    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    }
    
    const onDownload = () => {
        window.open(LeoDocumentsPath + '/' + LeoDocumentsPathExample);
    }

    return <Box>
        <Box display={"flex"} justifyContent={"space-between"}  alignItems={"center"}>
            <Typography fontSize={"16px"} lineHeight={"19.2px"} fontWeight={"600"}>{title}</Typography>
            <IconButton onClick={toggleCollapse}  size={"small"} aria-label={collapsed ? t('A11yExpand') : t('A11yCollapse')}>{collapsed ? <AddIcon /> : <RemoveIcon />}</IconButton>
        </Box>
        {!collapsed && <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
            {reports.map(r => <Box display={"flex"} justifyContent={"space-around"} key={`report-${r.id}`}  alignItems={"center"}>
                    <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"19.5px"} sx={{ textDecoration: "underline", flexBasis:"70px", flexGrow: 2}}>{r.name}</Typography>
                    <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"19.5px"} sx={{ flexBasis:"25px", flexGrow: 1}}>{r.date.getFullYear()}</Typography>
                    <Box display={"flex"} gap={"5px"} alignItems={"center"}>
                        <IconButton size={"small"} onClick={onDownload} aria-label={t('A11yShareDocument')}><ReplyIcon fontSize="small" /></IconButton>
                        <IconButton size={"small"} onClick={onDownload} aria-label={t('A11yDownloadDocument')}><VerticalAlignBottomIcon fontSize="small" /></IconButton>
                    </Box>
                </Box>)}
            </Box>}
    </Box>;
}

export default CollapsableReports;